import React from "react";
import { Layout } from "components/Layout/Layout";
import { UsersList } from "./components/UsersList";
import { AddNewBar } from "./components/AddNewBar";
import { UsersProvider } from "./context";

export const UsersPage = () => {
  return (
    <UsersProvider>
      <Layout>
        <AddNewBar />
        <UsersList />
      </Layout>
    </UsersProvider>
  );
};
